import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { updateVulnTemplate } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import { selectVulnTemplateDetail } from 'store/KnowledgeBase/selectors';
import { Container, CVEContainer, Title } from './styled';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import useExpandable from 'Hooks/useExpandable';
import CVE from 'Screens/Contextualization/ManageEditCreate/components/ManualCreationModal/components/General/InputCVE';
import CVSS from './components/CVSS';
import { selectRiskScoreFeatureFlag } from 'store/Faraday/selectors';

const TAB = 'general';
const ID = 'policies';

const RiskInformation = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const isAllowedByLicense = useSelector(selectRiskScoreFeatureFlag);
  const vulnTemplate = useSelector(selectVulnTemplateDetail);
  const cve = get(vulnTemplate, 'cve', []);
  const cvss2 = get(vulnTemplate, 'cvss2', {});
  const cvss3 = get(vulnTemplate, 'cvss3', {});
  const cvss4 = get(vulnTemplate, 'cvss4', {});
  const id = get(vulnTemplate, '_id', 0);
  const isExpanded = useExpandable(TAB, ID, cve, id);

  const onAdd = (valueAdded) => {
    const newRefs = [...cve, valueAdded];
    dispatch(updateVulnTemplate(id, { cve: newRefs }));
  };

  const onRemove = (elementToRemove) => {
    const newRefs = cve.filter((pol) => pol !== elementToRemove);
    dispatch(updateVulnTemplate(id, { cve: newRefs }));
  };

  return (
    <ExpandableWrapper defaultValue={ isExpanded } id="risk" title={ intl.formatMessage({ id: 'manage.detail.tab.general.risk' }) } tab={ TAB }>
      <Container>
        <CVEContainer>
          <Title children='CVE' />
          <CVE
            width="100%"
            listData={ cve }
            onAdd= { onAdd }
            onRemove={ onRemove }
          />
        </CVEContainer>
        { isAllowedByLicense && <CVSS cvss2={ cvss2 } cvss3={ cvss3 } cvss4={ cvss4 } /> }
      </Container>
    </ExpandableWrapper>
  );
};

export default RiskInformation;
